document.addEventListener( 'DOMContentLoaded', () => {
	class JTFSELECTOR {
		static SELECTOR_CLASS_INNER = '.jtf__selectorblock--inner'
		static SELECTOR_CLASS_CONTAINER = '.jtf__selectorblock--container'
		static SELECTOR_CLASS_DOT_ACTIVE = '.jtf__selectorblock--dot-active'
		static SELECTOR_CLASS_DOT = '.jtf__selectorblock--dot'
		static SELECTOR_CLASS_PREV = '.jtf__selectorblock--prev'
		static SELECTOR_CLASS_NEXT = '.jtf__selectorblock--next'
		static SELECTOR_CLASS_DOTS = '.jtf__selectorblock--dots'
		static SELECTOR_CLASS_NAV = '.jtf__selectorblock--nav'
		static SELECTOR_CLASS_ITEM = '.jtf__selectorblock--item'
		static SELECTOR_CLASS_SELECT = '.jtf__selectorblock--selector-select'
		static SELECTOR_CLASS_BUTTON = '.jtf__selectorblock--selector-button'
		static SELECTOR_CLASS_NAVIGATION = '.jtf__selectorblock--navigation'
		static SELECTOR_CLASS_WP_ADMIN = '.wp-admin'
		static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-selector'
		static CLASS_NAME_DOT_ACTIVE = 'jtf__selectorblock--dot-active'
		static CLASS_NAME_NAVIGATION_INACTIVE = 'jtf__selectorblock--navigation-inactive'
		static ATTR_DATA_POSITION = 'data-position'
		static ATTR_DATA_CHILDREN = 'data-children'
		static ATTR_DATA_TARGET = 'data-target'
		static ATTR_DATA_PARENT = 'data-parent'
		static ATTR_STYLE = 'style'
		static PANEL_ITEM_COUNT = 3
		static MOBILE_BREAKPOINT = 600
		static TIMEOUT_DELAY = 300

		constructor() {
			this.init()
		}

		navigateCarousel() {
			const inner = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_INNER )
			const container = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_CONTAINER )
			const position = parseInt( container.getAttribute( JTFSELECTOR.ATTR_DATA_POSITION ) )
			const translateX = -(inner.offsetWidth * position)
			inner.style.transform = `translateX(${translateX}px)`
		}

		setActiveDot( active ) {
			const activeDot = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_DOT_ACTIVE )
			if ( activeDot ) {
				activeDot.classList.remove( JTFSELECTOR.CLASS_NAME_DOT_ACTIVE )
			}

			const dots = document.querySelectorAll( JTFSELECTOR.SELECTOR_CLASS_DOT )
			dots.forEach( ( dot ) => {
				if ( parseInt( dot.getAttribute( JTFSELECTOR.ATTR_DATA_TARGET ) ) === parseInt( active ) ) {
					dot.classList.add( JTFSELECTOR.CLASS_NAME_DOT_ACTIVE )
				}
			} )
		}

		loadCarousel() {
			document.addEventListener( 'click', ( e ) => {
				if ( e.target.closest( JTFSELECTOR.SELECTOR_CLASS_PREV ) ) {
					const parent = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_CONTAINER )
					let position = parseInt( parent.getAttribute( JTFSELECTOR.ATTR_DATA_POSITION ) )
					parent.setAttribute( 'data-max', 'false' )

					if ( position > 0 ) {
						parent.setAttribute( JTFSELECTOR.ATTR_DATA_POSITION, position - 1 )
						this.setActiveDot( position - 1 )
						this.navigateCarousel()
					}

					if ( position === 1 ) {
						e.target.closest( JTFSELECTOR.SELECTOR_CLASS_PREV ).classList.add( JTFSELECTOR.CLASS_NAME_NAVIGATION_INACTIVE )
					}
				}

				if ( e.target.closest( JTFSELECTOR.SELECTOR_CLASS_NEXT ) ) {
					const parent = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_CONTAINER )
					let position = parseInt( parent.getAttribute( JTFSELECTOR.ATTR_DATA_POSITION ) )
					const inner = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_INNER )
					let innerChildren = parseInt( inner.getAttribute( JTFSELECTOR.ATTR_DATA_CHILDREN ) )
					const prev = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_PREV )

					prev.classList.remove( JTFSELECTOR.CLASS_NAME_NAVIGATION_INACTIVE )

					if ( (position + 1) < innerChildren ) {
						parent.setAttribute( JTFSELECTOR.ATTR_DATA_POSITION, position + 1 )
						this.setActiveDot( position + 1 )
						this.navigateCarousel()
					} else {
						prev.classList.add( JTFSELECTOR.CLASS_NAME_NAVIGATION_INACTIVE )
						parent.setAttribute( JTFSELECTOR.ATTR_DATA_POSITION, 0 )
						this.setActiveDot( 0 )
						this.navigateCarousel()
					}
				}

				if ( e.target.closest( JTFSELECTOR.SELECTOR_CLASS_DOT ) ) {
					const dot = e.target.closest( JTFSELECTOR.SELECTOR_CLASS_DOT )
					let position = parseInt( dot.getAttribute( JTFSELECTOR.ATTR_DATA_TARGET ) )
					const prev = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_PREV )
					const container = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_CONTAINER )

					container.setAttribute( JTFSELECTOR.ATTR_DATA_POSITION, position )
					this.setActiveDot( position )

					if ( position === 0 ) {
						prev.classList.add( JTFSELECTOR.CLASS_NAME_NAVIGATION_INACTIVE )
					} else {
						prev.classList.remove( JTFSELECTOR.CLASS_NAME_NAVIGATION_INACTIVE )
					}
					this.navigateCarousel()
				}
			} )
		}

		generateNavigation( slideCount ) {
			const parent = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_DOTS )
			const grandParent = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_NAV )
			const container = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_CONTAINER )
			const currentPosition = container.getAttribute( JTFSELECTOR.ATTR_DATA_POSITION )
			const styleAttr = container.getAttribute( JTFSELECTOR.ATTR_STYLE ) || ''

			grandParent.innerHTML = ''
			grandParent.appendChild( parent )

			const prevButton = document.createElement( 'a' )
			prevButton.className = 'jtf__selectorblock--prev jtf__selectorblock--navigation'
			if ( currentPosition === '0' ) {
				prevButton.classList.add( JTFSELECTOR.CLASS_NAME_NAVIGATION_INACTIVE )
			}
			prevButton.setAttribute( 'style', styleAttr )
			prevButton.href = 'javascript:void(0);'
			prevButton.innerHTML = '<i class="far fa-angle-left"></i>'
			parent.parentNode.insertBefore( prevButton, parent )

			const nextButton = document.createElement( 'a' )
			nextButton.className = 'jtf__selectorblock--next jtf__selectorblock--navigation'
			nextButton.href = 'javascript:void(0);'
			nextButton.setAttribute( 'style', styleAttr )
			nextButton.innerHTML = '<i class="far fa-angle-right"></i>'
			parent.parentNode.insertBefore( nextButton, parent.nextSibling )

			parent.innerHTML = ''

			for ( let x = 0; x < slideCount; x++ ) {
				const dotLink = document.createElement( 'a' )
				dotLink.href = '#'
				dotLink.className = 'jtf__selectorblock--dot'
				if ( x === 0 ) {
					dotLink.classList.add( JTFSELECTOR.CLASS_NAME_DOT_ACTIVE )
				}
				dotLink.setAttribute( JTFSELECTOR.ATTR_DATA_TARGET, x )
				dotLink.setAttribute( 'style', styleAttr )
				dotLink.innerHTML = '<i class="fas fa-circle"></i>'
				parent.appendChild( dotLink )
			}
		}

		removeNavigation() {
			const containers = document.querySelectorAll( JTFSELECTOR.SELECTOR_CLASS_NAVIGATION )
			containers.forEach( ( container ) => {
				container.innerHTML = ''
			} )
		}

		reboot() {
			let panelItemCount = JTFSELECTOR.PANEL_ITEM_COUNT

			if ( window.innerWidth < JTFSELECTOR.MOBILE_BREAKPOINT ) {
				panelItemCount = 1
			}

			const container = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_CONTAINER )
			const itemWidth = container.offsetWidth / panelItemCount
			const inner = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_INNER )

			container.setAttribute( JTFSELECTOR.ATTR_DATA_POSITION, 0 )
			inner.style.transform = 'translateX(0)'

			const wpAdmin = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_WP_ADMIN )
			if ( wpAdmin ) {
				setTimeout( () => {
					const items = document.querySelectorAll( JTFSELECTOR.SELECTOR_CLASS_ITEM )
					let childElCount = Math.ceil( items.length / panelItemCount )
					inner.setAttribute( JTFSELECTOR.ATTR_DATA_CHILDREN, childElCount )

					if ( childElCount > 1 ) {
						this.generateNavigation( childElCount )
					} else {
						this.removeNavigation()
					}

					items.forEach( ( item ) => {
						item.style.width = `${itemWidth}px`
						item.style.display = 'inline-block'
					} )
				}, JTFSELECTOR.TIMEOUT_DELAY )
			} else {
				const select = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_SELECT )
				const currentSelection = select ? select.value : null
				const items = document.querySelectorAll( JTFSELECTOR.SELECTOR_CLASS_ITEM )
				const matchingItems = currentSelection 
					? document.querySelectorAll( `${JTFSELECTOR.SELECTOR_CLASS_ITEM}[${JTFSELECTOR.ATTR_DATA_PARENT}="${currentSelection}"]` )
					: items
				let childElCount = Math.ceil( matchingItems.length / panelItemCount )
				inner.setAttribute( JTFSELECTOR.ATTR_DATA_CHILDREN, childElCount )

				if ( childElCount > 1 ) {
					this.generateNavigation( childElCount )
				} else {
					this.removeNavigation()
				}

				items.forEach( ( item ) => {
					item.style.width = `${itemWidth}px`
					if ( currentSelection && item.getAttribute( JTFSELECTOR.ATTR_DATA_PARENT ) === currentSelection ) {
						item.style.display = 'inline-block'
					} else if ( !currentSelection ) {
						item.style.display = 'inline-block'
					} else {
						item.style.display = 'none'
					}
				} )
			}
		}

		init() {
			const container = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_CONTAINER )
			if ( container ) {
				container.setAttribute( JTFSELECTOR.ATTR_DATA_POSITION, 0 )
			}

			document.addEventListener( 'click', ( e ) => {
				if ( e.target.closest( JTFSELECTOR.SELECTOR_CLASS_BUTTON ) ) {
					e.preventDefault()
					this.reboot()
				}
			} )

			this.loadCarousel()
		}
	}

	const wpAdmin = document.querySelector( JTFSELECTOR.SELECTOR_CLASS_WP_ADMIN )
	if ( wpAdmin ) {
		new JTFSELECTOR()
	} else {
		const blocks = document.querySelectorAll( JTFSELECTOR.SELECTOR_CLASS_BLOCK )
		if ( blocks.length > 0 ) {
			blocks.forEach( () => {
				new JTFSELECTOR()
			} )
		}
	}
} )
